import { createService } from "./createService"
import { SERVICE_INSTANCES } from "./serviceInstances"

const service = createService(SERVICE_INSTANCES.company)

export const COMPANY_INSTANCE = service.instanceKey

export const COMPANY_ENDPOINTS = {
  // Info
  GET_DEPARTMENTS: "/admin/company/getdepartments",
  GET_MANAGERS: "/admin/company/getmanagers",
  GET_MANAGER: "/admin/company/getmanager",
  SELECT_MANAGERS: "/admin/company/selectmanagers",
  GET_PAY_GRADES: "/admin/company/getpaygrades",
  GET_PAY_BANDS: "/admin/company/getpaybands",
  GET_OFFICE_ADDRESSES: "/admin/company/getofficeaddresses",
  GET_EMPLOYEES: "/admin/company/getemployees",
  GET_INDUSTRIES: "/admin/company/getindustries",
  GET_ADMINS: "/admin/company/getadmins",
  GET_PRIMARY_ADMIN: "/admin/company/getprimaryadmin",
  GET_PRIMARY_ALL_ADMIN: "/admin/company/getprimaryalladmin",
  NEW_ADMIN: "/admin/company/new_admin",
  ADD_NEW: "/admin/company/add_new",
  EDIT_INFO: "/admin/company/edit_info",
  CHANGE_ADMIN: "/admin/company/change_admin",
  UPDATE_ADMIN: "/admin/company/update_admin",
  REMOVE_ADMIN: "/admin/company/remove_admin",
  UPDATE_EXTERNAL_ADMIN: "/admin/company/updateexternaladmin",
  DELETE_EXTERNAL_ADMIN: "/admin/company/deleteexternaladmin",
  SIGN_DOCUMENT: "/admin/company/sign_document",
  SUBMIT_SETUP: "/admin/company/submit_setup",
  SUBMIT_VERIFICATION: "/admin/company/submit_verification",
  UPDATE_VERIFICATION: "/admin/company/update_verification",
  // Office addresses
  SWITCH_OFFICE_ADDRESS: "/admin/company/switch_officeaddress",
  ADD_OFFICE_ADDRESS: "/admin/company/add_officeaddress",
  UPDATE_OFFICE_ADDRESS: "/admin/company/update_officeaddress",
  ENABLE_OFFICE_ADDRESS: "/admin/company/enable_officeaddress",
  DISABLE_OFFICE_ADDRESS: "/admin/company/disable_officeaddress",
  VIEW_LOCATIONS: "/admin/company/view/locations",
  // Company info / statutory
  UPLOAD_IMAGE: "/admin/company/upload_image",
  GET_TYPES: "/admin/company/gettypes",
  GET_SIGNATORY_EMPLOYEES: "/admin/company/getsignatoryemployees",
  ADD_SIGNATORY: "/admin/company/add_signatory",
  SET_PRIMARY_SIGNATORY: "/admin/company/set_primary_signatory",
  REMOVE_SIGNATORY: "/admin/company/remove_signatory",
  EDIT_NSITF_DETAILS: "/admin/company/edit_nsitf_details",
  EDIT_ITF_DETAILS: "/admin/company/edit_itf_details",
  // Tax / compliance
  GET_HOUSING_LOCATIONS: "/admin/company/gethousinglocationsbystatecode",
  GET_TAX_OFFICES: "/admin/company/gettaxofficesbystatecode",
  GET_TAX_OFFICES_BY_CURRENCY_CODE: "/admin/company/gettaxofficesbycurrency",
  EDIT_HOUSING_DETAILS: "/admin/company/edit_housing_details",
  EDIT_TAX_DETAILS: "/admin/company/edit_tax_details",
  EDIT_PENSION_DETAILS: "/admin/company/edit_pension_details",
  // Pay grades / bands
  ADD_PAY_GRADE: "/admin/company/add_paygrade",
  UPDATE_PAYGRADE: "/admin/company/update_paygrade",
  PASTE_PAYGRADE: "/admin/company/paste_paygrade",
  ADD_PAY_BAND: "/admin/company/add_payband",
  UPDATE_PAYBAND: "/admin/company/update_payband",
  PASTE_PAYBAND: "/admin/company/paste_payband",
  CONFIGURE_PAY_GRADE: "/admin/company/configure_paygrade",
  CONFIGURE_PAY_BAND: "/admin/company/configure_payband",
  SELECT_PAY_GRADES: "/admin/company/selectpaygrades",
  // Settings toggles
  EDIT_PAYMENT_FILE: "/admin/company/editpaymentfile",
  EDIT_PAYMENT_NARRATION: "/admin/company/editpaymentnarration",
  EDIT_PAYMENT_PRORATION_STATUS: "/admin/company/editpaymentprorationstatus",
  EDIT_PAYROLL_ACCOUNT_PREFERENCE:
    "/admin/company/editpayrollaccountpreference",
  EDIT_WORKING_DAYS: "/admin/company/editworkingdays",
  SUBMIT_EWA: "/admin/company/submit_ewa",
  EDIT_AUTO_PAYROLL_STATUS: "/admin/company/editautopayrollstatus",
  EDIT_DIRECT_DEPOSIT_STATUS: "/admin/company/editdirectdepositstatus",
  EDIT_CHECK_PAYMENT_STATUS: "/admin/company/editcheckpaymentstatus",
  EDIT_CONFIRMATION_STATUS: "/admin/company/editconfirmationstatus",
  EDIT_EXTERNAL_LOAN_APPROVAL_STATUS:
    "/admin/company/editexternalloanapprovalstatus",
  TOGGLE_EXTERNAL_LOAN: "/admin/company/toggleexternalloan",
  EDIT_SPLIT_PAYMENT_STATUS: "/admin/company/editsplitpaymentstatus",
  EDIT_CROSS_ACCOUNT_REPORTING_STATUS:
    "/admin/company/editcrossaccountreportingstatus",
  UPDATE_EWA: "/admin/company/update_ewa",
  SELECT_INVOICES: "/admin/company/selectinvoices",
  SELECT_PAY_BANDS: "/admin/company/selectpaybands",
  EDIT_PAYROLL_WORKING_DAYS: "/admin/company/editpayrollworkingdays",
  LOG_PAYMENT: "/admin/company/logpayment_new",
  WALLET_VIEW_INDEX: "/admin/wallet/view/index",
  // Calendar
  LOAD_CALENDAR_EVENTS: "/admin/company/loadcalendarevents",
  // Departments
  ADD_DEPARTMENT: "/admin/departments/add",
  CHECK_DEPARTMENT: "/admin/departments/check",
  RENAME_DEPARTMENT: "/admin/departments/rename",
  SELECT_DEPARTMENTS: "/admin/departments/select",
  EDIT_DEPARTMENT_HEAD: "/admin/departments/edit_head",
  DELETE_DEPARTMENT: "/admin/departments/delete",
  GET_DEPARTMENT_PEOPLE: "/admin/departments/getothers",
  VIEW_DEPARTMENT_EDIT: "/admin/departments/view/edit",
  UPDATE_DEPARTMENT_PERSONS: "/admin/departments/update_persons",
  // Employee titles
  SELECT_TITLES: "/admin/company/selecttitles",
  ADD_TITLE: "/admin/company/add_title",
  UPDATE_TITLE: "/admin/company/update_title",
  REMOVE_TITLE: "/admin/company/remove_title",
  DISABLE_TITLE: "/admin/company/disable_title",
  // View
  VIEW_DETAILS: "/admin/company/view/details",
  VIEW_INVOICE: "/admin/company/view/invoice",
  // View settings
  VIEW_SETTINGS: "/admin/company/view/settings",
  GET_TAX_TABLE_CURRENCIES: "/admin/company/gettaxtablecurrencies",
  GET_TAX_ACTS: "/admin/company/gettaxacts",
  // Tax reliefs
  SELECT_TAX_RELIEFS: "/admin/company/selecttaxreliefs",
  GET_TAX_RELIEFS: "/admin/company/gettaxreliefs",
  ADD_TAX_RELIEF: "/admin/company/add_taxrelief",
  UPDATE_TAX_RELIEF: "/admin/company/update_taxrelief",
  DELETE_TAX_RELIEF: "/admin/company/delete_taxrelief",
  ENABLE_TAX_RELIEF: "/admin/company/enable_taxrelief",
  DISABLE_TAX_RELIEF: "/admin/company/disable_taxrelief",
  // Statutory benefits
  SELECT_STATUTORY_BENEFITS: "/admin/company/selectstatutorybenefits",
  GET_STATUTORY_BENEFITS: "/admin/company/getstatutorybenefits",
  ADD_STATUTORY_BENEFIT: "/admin/company/add_statutory_benefit",
  UPDATE_STATUTORY_BENEFIT: "/admin/company/update_statutory_benefit",
  REMOVE_STATUTORY_BENEFIT: "/admin/company/remove_statutory_benefit",
  ENABLE_STATUTORY_BENEFIT: "/admin/company/enable_statutory_benefit",
  DISABLE_STATUTORY_BENEFIT: "/admin/company/disable_statutory_benefit",
  // Allowances
  GET_ALLOWANCES: "/admin/company/getallowances",
  GET_ALLOWANCE: "/admin/company/getallowance",
  GET_ALLOWANCE_GROUPS: "/admin/company/getallowancegroups",
  ADD_ALLOWANCE: "/admin/company/add_allowance",
  UPDATE_ALLOWANCE: "/admin/company/update_allowance",
  REMOVE_ALLOWANCE: "/admin/company/remove_allowance",
  ENABLE_ALLOWANCE: "/admin/company/enable_allowance",
  DISABLE_ALLOWANCE: "/admin/company/disable_allowance",
  SELECT_ALLOWANCES: "/admin/company/selectallowances",
  ADD_ALLOWANCE_GROUP: "/admin/company/add_allowance_group",
  UPDATE_ALLOWANCE_GROUP: "/admin/company/update_allowance_group",
  GET_ALLOWANCE_GROUP: "/admin/company/get_allowance_group",
  REMOVE_ALLOWANCE_GROUP: "/admin/company/remove_allowance_group",
  DELETE_ALLOWANCE_GROUP: "/admin/company/delete_allowance_group",
  ENABLE_ALLOWANCE_GROUP: "/admin/company/enable_allowance_group",
  DISABLE_ALLOWANCE_GROUP: "/admin/company/disable_allowance_group",
  SELECT_DEFAULT_PAYGRADE_ALLOWANCES:
    "/admin/company/selectdefaultpaygradeallowances",
  // Payroll remittances / schedules
  GET_PAYROLL_REMITTANCES: "/admin/company/getpayrollremittances",
  GET_PAYROLL_SCHEDULES: "/admin/company/getpayrollSchedules",
  GET_MONTHLY_PAYROLL_SCHEDULES: "/admin/company/getmonthlypayrollschedules",
  GET_PAYROLL_SCHEDULE_OPTIONS: "/admin/company/getpayrollscheduleoptions",
  // Payroll schedule run/pay day options
  GET_RUN_DAY_OPTIONS_BY_CUTOFF_DAY_ID:
    "/admin/company/getpayrollschedulerundayoptionsbycutoffdayid",
  GET_PAY_DAY_OPTIONS_BY_RUN_DAY_ID:
    "/admin/company/getpayrollschedulepaydayoptionsbyrundayid",
  GET_CUTOFF_DAY2_OPTIONS_BY_CUTOFF_DAY1_ID:
    "/admin/company/getpayrollschedulecutoffday2optionsbycutoffday1id",
  GET_RUN_DAY2_OPTIONS_BY_RUN_DAY1_ID:
    "/admin/company/getpayrollschedulerunday2optionsbyrunday1id",
  GET_RUN_DAY_OPTIONS_BY_CUTOFF_DAY:
    "/admin/company/getpayrollschedulerundayoptionsbycutoffday",
  GET_PAY_DAY_OPTIONS_BY_RUN_DAY:
    "/admin/company/getpayrollschedulepaydayoptionsbyrunday",
  // Change types
  GET_CHANGE_TYPES: "/admin/payrolls/getchangetypes",
  // Paygrade/band enable/disable/remove
  ENABLE_PAYGRADE: "/admin/company/enable_paygrade",
  DISABLE_PAYGRADE: "/admin/company/disable_paygrade",
  REMOVE_PAYGRADE: "/admin/company/remove_paygrade",
  ENABLE_PAYBAND: "/admin/company/enable_payband",
  DISABLE_PAYBAND: "/admin/company/disable_payband",
  REMOVE_PAYBAND: "/admin/company/remove_payband",
  // Custom pay schedules
  SELECT_CUSTOM_PAY_SCHEDULES: "/admin/company/selectcustompayrollschedules",
  ADD_CUSTOM_SCHEDULE: "/admin/company/add_customschedule",
  UPDATE_CUSTOM_SCHEDULE: "/admin/company/update_customschedule",
  ENABLE_CUSTOM_SCHEDULE: "/admin/company/enable_customschedule",
  DISABLE_CUSTOM_SCHEDULE: "/admin/company/disable_customschedule",
  REMOVE_CUSTOM_SCHEDULE: "/admin/company/remove_customschedule",
  // Regular pay schedules
  SELECT_REGULAR_PAY_SCHEDULES: "/admin/company/selectpayrollschedules",
  UPDATE_REGULAR_SCHEDULE: "/admin/company/update_schedule",
  ENABLE_REGULAR_SCHEDULE: "/admin/company/enable_regularschedule",
  DISABLE_REGULAR_SCHEDULE: "/admin/company/disable_regularschedule",
  UPDATE_BI_REGULAR_SCHEDULE: "/admin/company/update_schedule",
  // Off-cycle schedules
  SELECT_OFF_CYCLE_SCHEDULES: "/admin/company/selectoffcyclepayrollschedules",
  ADD_OFF_CYCLE_SCHEDULE: "/admin/company/add_offcyclepayrollschedule",
  UPDATE_OFF_CYCLE_SCHEDULE: "/admin/company/update_offcyclepayrollschedule",
  REMOVE_OFF_CYCLE_SCHEDULE: "/admin/company/remove_offcyclepayrollschedule",
  ENABLE_OFF_CYCLE_SCHEDULE: "/admin/company/enable_offcyclepayrollschedule",
  DISABLE_OFF_CYCLE_SCHEDULE: "/admin/company/disable_offcyclepayrollschedule",
  // Paygrade allowance count for custom schedule
  GET_PAYGRADE_ALLOWANCE_COUNT:
    "/admin/company/getpaygradeallowancecountforcustompayrollschedule",
  // Policy groups
  SELECT_POLICY_GROUPS: "/admin/company/selectpolicygroups",
  DELETE_POLICY_GROUP: "/admin/company/delete_policy_group",
  VIEW_POLICY_GROUPS: "/admin/company/view/policy_groups",
  ADD_POLICY_GROUP: "/admin/company/add_policy_group",
  UPDATE_POLICY_GROUP: "/admin/company/update_policy_group",
  // Welcome messages
  GET_WELCOME_MESSAGES: "/admin/welcome_messages/get",
  // Integrations
  GET_DIRECT_DEPOSIT_INTEGRATION_STATUS:
    "/admin/company/getdirectdepositintegrationstatus",
  GET_FUSION_INTEGRATION_SETTING:
    "/admin/company/getfusionintegrationsetting",
  EDIT_FUSION_INTEGRATION_SETTING:
    "/admin/company/editfusionintegrationsetting",
  SELECT_FUSION_ALLOWANCE_DAYS: "/admin/company/selectfusionallowancedays",
  UPDATE_PAYROLL_CUT_OFF_CONFIGURATION:
    "/admin/company/updatepayrollcutoffconfiguration",
  GET_PAYROLL_CUT_OFF_CONFIGURATION:
    "/admin/company/getpayrollcutOffconfiguration",
  UPDATE_ARREARS_TEXT_CONFIGURATION:
    "/admin/company/updatearrearstextconfiguration",
  // Customization toggles
  EDIT_COWORKER_DIRECTORY_STATUS: "/admin/company/editcoworkerdirectorystatus",
  EDIT_BIRTHDAY_CARD_STATUS: "/admin/company/editbirthdaycardstatus",
  EDIT_ANNIVERSARY_CARD_STATUS: "/admin/company/editanniversarycardstatus",
  EDIT_COMPANY_GROUP_EMAIL: "/admin/company/editcompanygroupemail",
  EDIT_EMPLOYEE_REQUESTS_STATUS: "/admin/company/editemployeerequestsstatus",
  EDIT_EMPLOYEE_PROFILE_UPDATES_STATUS:
    "/admin/company/editemployeeprofileupdatesstatus",
  EDIT_EMPLOYEE_NOTIFICATIONS_STATUS:
    "/admin/company/editemployeenotificationsstatus",
  EDIT_APPROVAL_NOTIFICATIONS_STATUS:
    "/admin/company/editapprovalnotificationsstatus",
  EDIT_TIME_TRACKING_STATUS: "/admin/company/edittimetrackingstatus",
  EDIT_TAX_ACT_STATUS: "/admin/company/edittaxactstatus",
  EDIT_ACCOUNT_SWITCHING_STATUS: "/admin/company/editaccountswitchingstatus",
  EDIT_TWO_FACTOR_AUTHENTICATION_STATUS:
    "/admin/company/edittwofactorauthenticationstatus",
  EDIT_KEY_RESULT_REVIEW_STATUS: "/admin/company/editkeyresultreviewstatus",
} as const

export const companyService = {
  instanceKey: service.instanceKey,

  getDepartments: () => service.get(COMPANY_ENDPOINTS.GET_DEPARTMENTS),
  getManagers: (personId?: string | number, companyId?: string | number) =>
    service.get(COMPANY_ENDPOINTS.GET_MANAGERS, {
      ...(personId !== undefined ? { id: personId } : {}),
      ...(companyId !== undefined ? { company_id: companyId } : {}),
    }),
  getManager: (managerId: string | number) =>
    service.get(COMPANY_ENDPOINTS.GET_MANAGER, { id: managerId }),
  getPayGrades: (params?: { payTypeId?: number }) =>
    service.get(COMPANY_ENDPOINTS.GET_PAY_GRADES, params),
  getPayBands: (params?: { payTypeId?: number }) =>
    service.get(COMPANY_ENDPOINTS.GET_PAY_BANDS, params),
  getOfficeAddresses: (params?: Record<string, any>) =>
    service.get(COMPANY_ENDPOINTS.GET_OFFICE_ADDRESSES, params),
  getEmployees: () => service.get(COMPANY_ENDPOINTS.GET_EMPLOYEES),
  getPrimaryAdmin: () => service.get(COMPANY_ENDPOINTS.GET_PRIMARY_ADMIN),
  getIndustries: () => service.get(COMPANY_ENDPOINTS.GET_INDUSTRIES),
  getAdmins: (includePrimary?: boolean) =>
    service.get(COMPANY_ENDPOINTS.GET_ADMINS, { includePrimary }),
  newAdmin: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.NEW_ADMIN, body),
  editInfo: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_INFO, body),
  updateAdmin: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.UPDATE_ADMIN, body),
  changeAdmin: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.CHANGE_ADMIN, body),
  removeAdmin: (id: string | number) =>
    service.post(`${COMPANY_ENDPOINTS.REMOVE_ADMIN}?id=${id}`),
  signDocument: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.SIGN_DOCUMENT, body),
  submitSetup: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.SUBMIT_SETUP, body),
  submitVerification: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.SUBMIT_VERIFICATION, body),
  updateVerification: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.UPDATE_VERIFICATION, body),
  // Office addresses
  switchOfficeAddress: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.SWITCH_OFFICE_ADDRESS, body),
  addOfficeAddress: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.ADD_OFFICE_ADDRESS, body),
  updateOfficeAddress: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.UPDATE_OFFICE_ADDRESS, body),
  enableOfficeAddress: (id: string | number) =>
    service.post(`${COMPANY_ENDPOINTS.ENABLE_OFFICE_ADDRESS}?id=${id}`),
  disableOfficeAddress: (id: string | number) =>
    service.post(`${COMPANY_ENDPOINTS.DISABLE_OFFICE_ADDRESS}?id=${id}`),
  viewLocations: () => service.get(COMPANY_ENDPOINTS.VIEW_LOCATIONS),
  // Company info / statutory
  addNew: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.ADD_NEW, body),
  uploadImage: (formData: FormData) =>
    service.upload(COMPANY_ENDPOINTS.UPLOAD_IMAGE, formData),
  getCompanyTypes: () => service.get(COMPANY_ENDPOINTS.GET_TYPES),
  getSignatoryEmployees: () =>
    service.get(COMPANY_ENDPOINTS.GET_SIGNATORY_EMPLOYEES),
  addSignatory: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.ADD_SIGNATORY, body),
  setPrimarySignatory: (id: string | number) =>
    service.post(`${COMPANY_ENDPOINTS.SET_PRIMARY_SIGNATORY}?id=${id}`),
  removeSignatory: (id: string | number) =>
    service.post(`${COMPANY_ENDPOINTS.REMOVE_SIGNATORY}?id=${id}`),
  editNsitfDetails: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_NSITF_DETAILS, body),
  editItfDetails: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_ITF_DETAILS, body),
  // Tax / compliance
  getHousingLocations: (stateCode: string) =>
    service.post(`${COMPANY_ENDPOINTS.GET_HOUSING_LOCATIONS}?id=${stateCode}`),
  getTaxOffices: (stateCode: string) =>
    service.get(COMPANY_ENDPOINTS.GET_TAX_OFFICES, { id: stateCode }),
  getTaxOfficesByCurrencyCode: (currencyCode: string) =>
    service.get(COMPANY_ENDPOINTS.GET_TAX_OFFICES_BY_CURRENCY_CODE, {
      currency_code: currencyCode,
    }),
  editHousingDetails: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_HOUSING_DETAILS, body),
  editTaxDetails: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_TAX_DETAILS, body),
  editPensionDetails: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_PENSION_DETAILS, body),
  // Pay grades/bands
  addPayGrade: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.ADD_PAY_GRADE, body),
  addPayBand: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.ADD_PAY_BAND, body),
  addPayBandForPerson: (personKey: string, body: Record<string, any>) =>
    service.post(
      `${COMPANY_ENDPOINTS.ADD_PAY_BAND}?person_key=${personKey}`,
      body
    ),
  configurePayGrade: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.CONFIGURE_PAY_GRADE, body),
  configurePayBand: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.CONFIGURE_PAY_BAND, body),
  selectPayGrades: (
    paybandId?: string | number,
    params?: {
      pageNumber?: number
      pageSize?: number
      searchParams?: string
      [key: string]: any
    }
  ) =>
    service.get(
      COMPANY_ENDPOINTS.SELECT_PAY_GRADES,
      paybandId ? { paybandId, ...params } : params
    ),
  // Calendar
  loadCalendarEvents: (from: string, to: string) =>
    service.get(COMPANY_ENDPOINTS.LOAD_CALENDAR_EVENTS, { from, to }),
  // Departments
  addDepartment: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.ADD_DEPARTMENT, body),
  selectTitles: (params?: {
    searchParams?: string
    pageNumber?: number
    pageSize?: number
  }) => service.get(COMPANY_ENDPOINTS.SELECT_TITLES, params),
  checkDepartment: (description: string) =>
    service.get(COMPANY_ENDPOINTS.CHECK_DEPARTMENT, { description }),
  renameDepartment: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.RENAME_DEPARTMENT, body),
  selectManagers: (params?: {
    pageNumber?: number
    pageSize?: number
    searchParams?: string
  }) => service.get(COMPANY_ENDPOINTS.SELECT_MANAGERS, params),
  addEmployeeTitle: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.ADD_TITLE, body),
  updateEmployeeTitle: (id: string | number, body: Record<string, any>) =>
    service.post(`${COMPANY_ENDPOINTS.UPDATE_TITLE}?id=${id}`, body),
  deleteEmployeeTitle: (id: string | number, force: boolean) =>
    service.post(
      `${COMPANY_ENDPOINTS.REMOVE_TITLE}?id=${id}&force=${
        force ? "true" : "false"
      }`
    ),
  disableEmployeeTitle: (id: string | number, body?: Record<string, any>) =>
    service.post(`${COMPANY_ENDPOINTS.DISABLE_TITLE}?id=${id}`, body),
  updateExternalAdmin: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.UPDATE_EXTERNAL_ADMIN, body),
  deleteExternalAdmin: (id: string) =>
    service.post(`${COMPANY_ENDPOINTS.DELETE_EXTERNAL_ADMIN}?id=${id}`),
  viewDepartmentEdit: (id: string) =>
    service.get(COMPANY_ENDPOINTS.VIEW_DEPARTMENT_EDIT, { id }),
  updateDepartmentPersons: (
    departmentId: string | number,
    body: Record<string, any>[]
  ) =>
    service.post(
      `${COMPANY_ENDPOINTS.UPDATE_DEPARTMENT_PERSONS}?id=${departmentId}`,
      body
    ),
  selectDepartments: (params?: {
    pageNumber?: number
    pageSize?: number
    searchParams?: string
    [key: string]: any
  }) => service.get(COMPANY_ENDPOINTS.SELECT_DEPARTMENTS, params),
  editDepartmentHead: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_DEPARTMENT_HEAD, body),
  deleteDepartment: (body: Record<string, any>) =>
    service.post(
      `${COMPANY_ENDPOINTS.DELETE_DEPARTMENT}?id=${
        body.id
      }&comment=${encodeURIComponent(body.comment ?? "")}`
    ),
  getDepartmentPeople: (body?: Record<string, any>) =>
    service.get(COMPANY_ENDPOINTS.GET_DEPARTMENT_PEOPLE, body),
  editAutoPayrollStatus: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_AUTO_PAYROLL_STATUS, body),
  editPaymentFile: (body: { fields: string[] }) =>
    service.post(COMPANY_ENDPOINTS.EDIT_PAYMENT_FILE, body),
  editPaymentNarration: (body: {
    format: string
    prefix: string
    suffix: string
  }) => service.post(COMPANY_ENDPOINTS.EDIT_PAYMENT_NARRATION, body),
  editPaymentProrationStatus: (body: {
    enable_regular_allowance_proration: string
    enable_special_allowance_proration: string
  }) => service.post(COMPANY_ENDPOINTS.EDIT_PAYMENT_PRORATION_STATUS, body),
  editPayrollAccountPreference: (body: {
    regular_payroll_account_class_id: string | null
    offcycle_payroll_account_class_id: string | null
  }) => service.post(COMPANY_ENDPOINTS.EDIT_PAYROLL_ACCOUNT_PREFERENCE, body),
  editWorkingDays: (workingDays: string) =>
    service.post(COMPANY_ENDPOINTS.EDIT_WORKING_DAYS, {
      working_days: workingDays,
    }),
  submitEwa: () => service.post(COMPANY_ENDPOINTS.SUBMIT_EWA),
  editDirectDepositStatus: (body: { enableDirectDeposit: string }) =>
    service.post(COMPANY_ENDPOINTS.EDIT_DIRECT_DEPOSIT_STATUS, body),
  editCheckPaymentStatus: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_CHECK_PAYMENT_STATUS, body),
  editConfirmationStatus: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_CONFIRMATION_STATUS, body),
  editExternalLoanApprovalStatus: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_EXTERNAL_LOAN_APPROVAL_STATUS, body),
  toggleExternalLoan: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.TOGGLE_EXTERNAL_LOAN, body),
  editSplitPaymentStatus: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_SPLIT_PAYMENT_STATUS, body),
  editCrossAccountReportingStatus: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_CROSS_ACCOUNT_REPORTING_STATUS, body),
  updateEwa: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.UPDATE_EWA, body),
  selectInvoices: (params: { statusId: number; [key: string]: any }) =>
    service.get(`${COMPANY_ENDPOINTS.SELECT_INVOICES}`, { ...params }),
  viewWalletIndex: () => service.get(COMPANY_ENDPOINTS.WALLET_VIEW_INDEX),
  logPayment: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.LOG_PAYMENT, body),
  editPayrollWorkingDays: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_PAYROLL_WORKING_DAYS, body),
  selectPayBands: (params?: {
    pageNumber?: number
    pageSize?: number
    searchParams?: string
    [key: string]: any
  }) => service.get(COMPANY_ENDPOINTS.SELECT_PAY_BANDS, params),
  selectPayGradesPost: (params?: {
    pageNumber?: number
    pageSize?: number
    searchParams?: string
    [key: string]: any
  }) => service.get(COMPANY_ENDPOINTS.SELECT_PAY_GRADES, params),
  // View
  viewDetails: () => service.get(COMPANY_ENDPOINTS.VIEW_DETAILS),
  viewInvoice: (invoiceId: string | number) =>
    service.get(COMPANY_ENDPOINTS.VIEW_INVOICE, {
      id: "details",
      x: invoiceId,
    }),
  getTaxTableCurrency: () =>
    service.get(COMPANY_ENDPOINTS.GET_TAX_TABLE_CURRENCIES),
  getTaxActs: (currencyCode?: string) =>
    service.get(
      `${COMPANY_ENDPOINTS.GET_TAX_ACTS}${
        currencyCode ? `?currency_code=${currencyCode}` : ""
      }`
    ),
  // View settings
  viewSettings: (
    idOrParams: string | { id: string; x?: string; [key: string]: any },
    x?: string,
    currency_code?: string,
    tax_act?: string
  ) =>
    typeof idOrParams === "string"
      ? service.get(COMPANY_ENDPOINTS.VIEW_SETTINGS, {
          id: idOrParams,
          ...(x ? { x } : {}),
          ...(currency_code ? { currency_code, tax_act } : {}),
        })
      : service.get(COMPANY_ENDPOINTS.VIEW_SETTINGS, { ...idOrParams }),
  // Tax reliefs
  selectTaxReliefs: (params?: Record<string, any>) =>
    service.get(COMPANY_ENDPOINTS.SELECT_TAX_RELIEFS, params),
  getTaxReliefs: () => service.get(COMPANY_ENDPOINTS.GET_TAX_RELIEFS),
  addTaxRelief: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.ADD_TAX_RELIEF, body),
  updateTaxRelief: (id: string | number, body: Record<string, any>) =>
    service.post(`${COMPANY_ENDPOINTS.UPDATE_TAX_RELIEF}?id=${id}`, body),
  deleteTaxRelief: (id: string | number) =>
    service.post(`${COMPANY_ENDPOINTS.DELETE_TAX_RELIEF}?id=${id}`),
  enableTaxRelief: (id: string | number) =>
    service.post(`${COMPANY_ENDPOINTS.ENABLE_TAX_RELIEF}?id=${id}`),
  disableTaxRelief: (id: string | number, comment: string) =>
    service.post(
      `${COMPANY_ENDPOINTS.DISABLE_TAX_RELIEF}?id=${id}&comment=${comment}`
    ),
  // Statutory benefits
  selectStatutoryBenefits: (params: Record<string, any>) =>
    service.get(COMPANY_ENDPOINTS.SELECT_STATUTORY_BENEFITS, params),
  getStatutoryBenefits: (currencyCode?: string) =>
    service.get(
      COMPANY_ENDPOINTS.GET_STATUTORY_BENEFITS,
      currencyCode ? { currency_code: currencyCode } : undefined
    ),
  addStatutoryBenefit: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.ADD_STATUTORY_BENEFIT, body),
  updateStatutoryBenefit: (id: string | number, body: Record<string, any>) =>
    service.post(
      `${COMPANY_ENDPOINTS.UPDATE_STATUTORY_BENEFIT}?id=${id}`,
      body
    ),
  removeStatutoryBenefit: (id: string | number, comment: string) =>
    service.post(
      `${COMPANY_ENDPOINTS.REMOVE_STATUTORY_BENEFIT}?id=${id}&comment=${comment}`
    ),
  enableStatutoryBenefit: (id: string | number) =>
    service.post(`${COMPANY_ENDPOINTS.ENABLE_STATUTORY_BENEFIT}?id=${id}`),
  disableStatutoryBenefit: (id: string | number, comment: string) =>
    service.post(
      `${COMPANY_ENDPOINTS.DISABLE_STATUTORY_BENEFIT}?id=${id}&comment=${comment}`
    ),
  // Allowances
  getAllowances: () => service.get(COMPANY_ENDPOINTS.GET_ALLOWANCES),
  getAllowancesForPayment: () =>
    service.get(`${COMPANY_ENDPOINTS.GET_ALLOWANCES}?forpayment=true`),
  getAllowance: (id: string | number) =>
    service.get(COMPANY_ENDPOINTS.GET_ALLOWANCE, { id }),
  addAllowance: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.ADD_ALLOWANCE, body),
  updateAllowance: (id: string | number, body: Record<string, any>) =>
    service.post(`${COMPANY_ENDPOINTS.UPDATE_ALLOWANCE}?id=${id}`, body),
  removeAllowance: (id: string | number, comment: string) =>
    service.post(
      `${COMPANY_ENDPOINTS.REMOVE_ALLOWANCE}?id=${id}&comment=${comment}`
    ),
  enableAllowance: (id: string | number) =>
    service.post(`${COMPANY_ENDPOINTS.ENABLE_ALLOWANCE}?id=${id}`),
  disableAllowance: (id: string | number, comment: string) =>
    service.post(
      `${COMPANY_ENDPOINTS.DISABLE_ALLOWANCE}?id=${id}&comment=${comment}`
    ),
  selectAllowances: (params?: Record<string, any>) =>
    service.get(COMPANY_ENDPOINTS.SELECT_ALLOWANCES, params),
  addAllowanceGroup: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.ADD_ALLOWANCE_GROUP, body),
  updateAllowanceGroup: (id: string | number, body: Record<string, any>) =>
    service.post(`${COMPANY_ENDPOINTS.UPDATE_ALLOWANCE_GROUP}?id=${id}`, body),
  getAllowanceGroup: (id: string | number) =>
    service.get(COMPANY_ENDPOINTS.GET_ALLOWANCE_GROUP, { id }),
  removeAllowanceGroup: (id: string | number, comment: string) =>
    service.post(
      `${COMPANY_ENDPOINTS.REMOVE_ALLOWANCE_GROUP}?id=${id}&comment=${comment}`
    ),
  deleteAllowanceGroup: (id: string | number, comment: string) =>
    service.post(
      `${COMPANY_ENDPOINTS.DELETE_ALLOWANCE_GROUP}?id=${id}&comment=${comment}`
    ),
  enableAllowanceGroup: (id: string | number) =>
    service.post(`${COMPANY_ENDPOINTS.ENABLE_ALLOWANCE_GROUP}?id=${id}`),
  disableAllowanceGroup: (id: string | number, comment: string) =>
    service.post(
      `${COMPANY_ENDPOINTS.DISABLE_ALLOWANCE_GROUP}?id=${id}&comment=${comment}`
    ),
  selectDefaultPaygradeAllowances: () =>
    service.get(COMPANY_ENDPOINTS.SELECT_DEFAULT_PAYGRADE_ALLOWANCES),
  // Payroll remittances / schedules
  getPayrollRemittances: () =>
    service.get(COMPANY_ENDPOINTS.GET_PAYROLL_REMITTANCES),
  getPayrollSchedules: (params?: {
    forallowance?: boolean
    forpayment?: boolean
  }) => service.get(COMPANY_ENDPOINTS.GET_PAYROLL_SCHEDULES, params),
  // Paygrade enable/disable/remove
  enablePaygrade: (id: string | number) =>
    service.post(`${COMPANY_ENDPOINTS.ENABLE_PAYGRADE}?id=${id}`),
  disablePaygrade: (id: string | number, comment: string) =>
    service.post(
      `${COMPANY_ENDPOINTS.DISABLE_PAYGRADE}?id=${id}&comment=${comment}`
    ),
  removePaygrade: (id: string | number, comment: string) =>
    service.post(
      `${COMPANY_ENDPOINTS.REMOVE_PAYGRADE}?id=${id}&comment=${comment}`
    ),
  // Payband enable/disable/remove
  enablePayband: (id: string | number) =>
    service.post(`${COMPANY_ENDPOINTS.ENABLE_PAYBAND}?id=${id}`),
  disablePayband: (id: string | number, comment: string) =>
    service.post(
      `${COMPANY_ENDPOINTS.DISABLE_PAYBAND}?id=${id}&comment=${comment}`
    ),
  removePayband: (id: string | number, comment: string) =>
    service.post(
      `${COMPANY_ENDPOINTS.REMOVE_PAYBAND}?id=${id}&comment=${comment}`
    ),
  // Custom pay schedules
  selectCustomPaySchedules: (params?: Record<string, any>) =>
    service.get(COMPANY_ENDPOINTS.SELECT_CUSTOM_PAY_SCHEDULES, params),
  addCustomSchedule: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.ADD_CUSTOM_SCHEDULE, body),
  updateCustomSchedule: (id: string | number, body: Record<string, any>) =>
    service.post(`${COMPANY_ENDPOINTS.UPDATE_CUSTOM_SCHEDULE}?id=${id}`, body),
  enableCustomSchedule: (id: string | number) =>
    service.post(`${COMPANY_ENDPOINTS.ENABLE_CUSTOM_SCHEDULE}?id=${id}`),
  disableCustomSchedule: (id: string | number) =>
    service.post(`${COMPANY_ENDPOINTS.DISABLE_CUSTOM_SCHEDULE}?id=${id}`),
  removeCustomSchedule: (id: string | number) =>
    service.post(`${COMPANY_ENDPOINTS.REMOVE_CUSTOM_SCHEDULE}?id=${id}`),
  // Regular pay schedules
  selectRegularPaySchedules: (params: Record<string, unknown>) =>
    service.get(COMPANY_ENDPOINTS.SELECT_REGULAR_PAY_SCHEDULES, params),
  updateRegularSchedule: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.UPDATE_REGULAR_SCHEDULE, body),
  enableRegularSchedule: (id: string | number) =>
    service.post(`${COMPANY_ENDPOINTS.ENABLE_REGULAR_SCHEDULE}?id=${id}`),
  disableRegularSchedule: (id: string | number, comment: string) =>
    service.post(
      `${COMPANY_ENDPOINTS.DISABLE_REGULAR_SCHEDULE}?id=${id}&comment=${comment}`
    ),
  updateBiRegularSchedule: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.UPDATE_BI_REGULAR_SCHEDULE, body),
  // Off-cycle pay schedules
  selectOffCycleSchedules: () =>
    service.get(COMPANY_ENDPOINTS.SELECT_OFF_CYCLE_SCHEDULES),
  addOffCycleSchedule: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.ADD_OFF_CYCLE_SCHEDULE, body),
  updateOffCycleSchedule: (id: string | number, body: Record<string, any>) =>
    service.post(
      `${COMPANY_ENDPOINTS.UPDATE_OFF_CYCLE_SCHEDULE}?id=${id}`,
      body
    ),
  removeOffCycleSchedule: (id: string | number) =>
    service.post(`${COMPANY_ENDPOINTS.REMOVE_OFF_CYCLE_SCHEDULE}?id=${id}`),
  enableOffCycleSchedule: (id: string | number) =>
    service.post(`${COMPANY_ENDPOINTS.ENABLE_OFF_CYCLE_SCHEDULE}?id=${id}`),
  disableOffCycleSchedule: (id: string | number) =>
    service.post(`${COMPANY_ENDPOINTS.DISABLE_OFF_CYCLE_SCHEDULE}?id=${id}`),
  // Paygrade allowance count
  getPaygradeAllowanceCount: (
    allowance_id: string | number,
    payroll_schedule_id?: string | number,
    pay_periodId?: string | number
  ) =>
    service.get(COMPANY_ENDPOINTS.GET_PAYGRADE_ALLOWANCE_COUNT, {
      allowance_id,
      ...(payroll_schedule_id ? { payroll_schedule_id } : {}),
      ...(pay_periodId ? { pay_periodId } : {}),
    }),
  // Update/paste paygrade/payband
  updatePaygrade: (
    id: string | number,
    comment: string,
    body: Record<string, any>
  ) =>
    service.post(
      `${COMPANY_ENDPOINTS.UPDATE_PAYGRADE}?id=${id}&comment=${comment}`,
      body
    ),
  pastePaygrade: (
    id: string | number,
    comment: string,
    body: Record<string, any>
  ) =>
    service.post(
      `${COMPANY_ENDPOINTS.PASTE_PAYGRADE}?id=${id}&comment=${comment}`,
      body
    ),
  // "Copy" flow (EditPaygrade.tsx): creates a new paygrade from another's
  // settings — no source id/comment in the request, just the full payload.
  copyPaygrade: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.PASTE_PAYGRADE, body),
  updatePayband: (
    id: string | number,
    comment: string,
    body: Record<string, any>
  ) =>
    service.post(
      `${COMPANY_ENDPOINTS.UPDATE_PAYBAND}?id=${id}&comment=${comment}`,
      body
    ),
  pastePayband: (
    id: string | number,
    comment: string,
    body: Record<string, any>
  ) =>
    service.post(
      `${COMPANY_ENDPOINTS.PASTE_PAYBAND}?id=${id}&comment=${comment}`,
      body
    ),
  // "Copy" flow (EditPayband.tsx): creates a new payband from another's
  // settings — no source id/comment in the request, just the full payload.
  copyPayband: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.PASTE_PAYBAND, body),
  addPayGradeForPerson: (personKey: string, body: Record<string, any>) =>
    service.post(
      `${COMPANY_ENDPOINTS.ADD_PAY_GRADE}?person_key=${personKey}`,
      body
    ),
  addPayGradeBase: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.ADD_PAY_GRADE, body),
  getMonthlyPayrollSchedules: (forAllowance?: boolean) =>
    service.get(
      COMPANY_ENDPOINTS.GET_MONTHLY_PAYROLL_SCHEDULES,
      forAllowance !== undefined ? { forAllowance } : undefined
    ),
  getPayrollScheduleOptions: (id: string | number, x: string | number) =>
    service.get(COMPANY_ENDPOINTS.GET_PAYROLL_SCHEDULE_OPTIONS, { id, x }),
  getRunDayOptionsByCutOffDayId: (
    id: string | number,
    cutOffId: string | number,
    s?: string | number
  ) =>
    service.get(
      COMPANY_ENDPOINTS.GET_RUN_DAY_OPTIONS_BY_CUTOFF_DAY_ID,
      s !== undefined ? { id, x: cutOffId, s } : { id, x: cutOffId }
    ),
  getPayDayOptionsByRunDayId: (
    id: string | number,
    runDayId: string | number,
    s?: string | number
  ) =>
    service.get(
      COMPANY_ENDPOINTS.GET_PAY_DAY_OPTIONS_BY_RUN_DAY_ID,
      s !== undefined ? { id, x: runDayId, s } : { id, x: runDayId }
    ),
  getCutOffDay2OptionsByCutOffDay1Id: (cutOffDay1Id: string | number) =>
    service.get(COMPANY_ENDPOINTS.GET_CUTOFF_DAY2_OPTIONS_BY_CUTOFF_DAY1_ID, {
      id: cutOffDay1Id,
    }),
  getRunDay2OptionsByRunDay1Id: (runDay1Id: string | number) =>
    service.get(COMPANY_ENDPOINTS.GET_RUN_DAY2_OPTIONS_BY_RUN_DAY1_ID, {
      id: runDay1Id,
    }),
  getRunDayOptionsByCutOffDay: (
    id: string | number,
    cutOffTitle: string,
    s?: string | number
  ) =>
    service.get(
      COMPANY_ENDPOINTS.GET_RUN_DAY_OPTIONS_BY_CUTOFF_DAY,
      s !== undefined ? { id, x: cutOffTitle, s } : { id, x: cutOffTitle }
    ),
  getPayDayOptionsByRunDay: (
    id: string | number,
    runDayTitle: string,
    s?: string | number
  ) =>
    service.get(
      COMPANY_ENDPOINTS.GET_PAY_DAY_OPTIONS_BY_RUN_DAY,
      s !== undefined ? { id, x: runDayTitle, s } : { id, x: runDayTitle }
    ),
  getPayrollRemittancesById: (id: string | number, forChange?: boolean) =>
    service.get(
      COMPANY_ENDPOINTS.GET_PAYROLL_REMITTANCES,
      forChange !== undefined ? { id, forChange } : { id }
    ),
  getAllowanceGroups: () => service.get(COMPANY_ENDPOINTS.GET_ALLOWANCE_GROUPS),
  getPayGradesPost: () => service.get(COMPANY_ENDPOINTS.GET_PAY_GRADES),
  getPayBandsPost: () => service.get(COMPANY_ENDPOINTS.GET_PAY_BANDS),
  getChangeTypes: () => service.get(COMPANY_ENDPOINTS.GET_CHANGE_TYPES),
  selectPolicyGroups: (params?: {
    pageNumber?: number
    pageSize?: number
    searchParams?: string
    [key: string]: any
  }) => service.get(COMPANY_ENDPOINTS.SELECT_POLICY_GROUPS, params),
  deletePolicyGroup: (id: string) =>
    service.post(`${COMPANY_ENDPOINTS.DELETE_POLICY_GROUP}?id=${id}`),
  getWelcomeMessages: () =>
    service.get(COMPANY_ENDPOINTS.GET_WELCOME_MESSAGES, { id: 1 }),
  viewPolicyGroup: (id: string | number) =>
    service.get(COMPANY_ENDPOINTS.VIEW_POLICY_GROUPS, { id }),
  addPolicyGroup: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.ADD_POLICY_GROUP, body),
  updatePolicyGroup: (id: string | number, body: Record<string, any>) =>
    service.post(`${COMPANY_ENDPOINTS.UPDATE_POLICY_GROUP}?id=${id}`, body),
  getAtsConfigSetting: (companyId: string | number) =>
    service.get(`/admin/company/getatsconfigsetting`, { id: companyId }),
  updateAtsConfigSetting: (body: Record<string, any>) =>
    service.post(`/admin/company/updateatsconfigsetting`, body),
  getDirectDepositIntegrationStatus: () =>
    service.get(COMPANY_ENDPOINTS.GET_DIRECT_DEPOSIT_INTEGRATION_STATUS),
  getFusionIntegrationSetting: () =>
    service.get(COMPANY_ENDPOINTS.GET_FUSION_INTEGRATION_SETTING),
  editFusionIntegrationSetting: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_FUSION_INTEGRATION_SETTING, body),
  selectFusionAllowanceDays: (params: { id: number; year?: number }) =>
    service.get(COMPANY_ENDPOINTS.SELECT_FUSION_ALLOWANCE_DAYS, params),
  updatePayrollCutOffConfiguration: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.UPDATE_PAYROLL_CUT_OFF_CONFIGURATION, body),
  updateArrearsTextConfiguration: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.UPDATE_ARREARS_TEXT_CONFIGURATION, body),
  getPayrollCutOffConfiguration: () =>
    service.get(COMPANY_ENDPOINTS.GET_PAYROLL_CUT_OFF_CONFIGURATION),
  // Customization toggles
  editCoworkerDirectoryStatus: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_COWORKER_DIRECTORY_STATUS, body),
  editBirthdayCardStatus: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_BIRTHDAY_CARD_STATUS, body),
  editAnniversaryCardStatus: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_ANNIVERSARY_CARD_STATUS, body),
  editCompanyGroupEmail: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_COMPANY_GROUP_EMAIL, body),
  editEmployeeRequestsStatus: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_EMPLOYEE_REQUESTS_STATUS, body),
  editEmployeeProfileUpdatesStatus: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_EMPLOYEE_PROFILE_UPDATES_STATUS, body),
  editEmployeeNotificationsStatus: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_EMPLOYEE_NOTIFICATIONS_STATUS, body),
  editApprovalNotificationsStatus: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_APPROVAL_NOTIFICATIONS_STATUS, body),
  editTimeTrackingStatus: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_TIME_TRACKING_STATUS, body),
  editTaxActStatus: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_TAX_ACT_STATUS, body),
  editAccountSwitchingStatus: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_ACCOUNT_SWITCHING_STATUS, body),
  editTwoFactorAuthenticationStatus: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_TWO_FACTOR_AUTHENTICATION_STATUS, body),
  editKeyResultReviewStatus: (body: Record<string, any>) =>
    service.post(COMPANY_ENDPOINTS.EDIT_KEY_RESULT_REVIEW_STATUS, body),
}
